"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalStepperItem = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var HorizontalStepperItemContainer = styled_components_1.default.div.attrs({
    className: 'tws-horizontal-stepper-item-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tpadding-bottom: 6px;\n\tborder-bottom: ", ";\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\twidth: auto;\n\t\toverflow-x: hidden;\n\t}\n"], ["\n\tdisplay: flex;\n\tpadding-bottom: 6px;\n\tborder-bottom: ", ";\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\twidth: auto;\n\t\toverflow-x: hidden;\n\t}\n"])), function (props) { return (props.active ? "4px solid ".concat(globalVars_module_scss_1.default.mainBlue, "; ") : '0'); });
HorizontalStepperItemContainer.displayName = 'HorizontalStepperItemContainer';
var HorizontalStepperItemStepNumber = styled_components_1.default.div.attrs({
    className: 'tws-horizontal-stepper-number',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tfont-size: 12px;\n\tfont-weight: 700;\n\tline-height: 1.5em;\n\tcolor: #ffffff;\n\tbackground-color: ", ";\n\twidth: 18px;\n\theight: 18px;\n\ttext-align: center;\n\tborder-radius: 10px;\n"], ["\n\tfont-size: 12px;\n\tfont-weight: 700;\n\tline-height: 1.5em;\n\tcolor: #ffffff;\n\tbackground-color: ", ";\n\twidth: 18px;\n\theight: 18px;\n\ttext-align: center;\n\tborder-radius: 10px;\n"])), function (props) { return (props.active ? "".concat(globalVars_module_scss_1.default.mainBlue) : "".concat(globalVars_module_scss_1.default.secondaryGray2)); });
HorizontalStepperItemStepNumber.displayName = 'HorizontalStepperItemStepNumber';
var HorizontalStepperItemText = styled_components_1.default.div.attrs({
    className: 'tws-horizontal-stepper-item-text',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-size: 13px;\n\tfont-weight: 700;\n\ttext-transform: uppercase;\n\tmargin-left: 10px;\n\tcolor: ", ";\n\tmax-width: 175px;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tmargin-left: 5px;\n\t\tmax-width: 40px;\n\t}\n"], ["\n\tfont-size: 13px;\n\tfont-weight: 700;\n\ttext-transform: uppercase;\n\tmargin-left: 10px;\n\tcolor: ", ";\n\tmax-width: 175px;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tmargin-left: 5px;\n\t\tmax-width: 40px;\n\t}\n"])), function (props) { return (props.active ? "".concat(globalVars_module_scss_1.default.mainBlue) : "".concat(globalVars_module_scss_1.default.secondaryGray2)); });
HorizontalStepperItemText.displayName = 'HorizontalStepperItemText';
var HorizontalStepperItem = /** @class */ (function (_super) {
    __extends(HorizontalStepperItem, _super);
    function HorizontalStepperItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HorizontalStepperItem.prototype.render = function () {
        var _a = this.props, active = _a.active, item = _a.item, stepNo = _a.stepNo;
        return (React.createElement(HorizontalStepperItemContainer, { active: active, title: item.text },
            React.createElement(HorizontalStepperItemStepNumber, { active: active }, stepNo),
            React.createElement(HorizontalStepperItemText, { active: active }, item.text)));
    };
    return HorizontalStepperItem;
}(React.Component));
exports.HorizontalStepperItem = HorizontalStepperItem;
var templateObject_1, templateObject_2, templateObject_3;
